export default class StatusBar {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new StatusBar;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-status-bar-remove', function(e) {
			self.removeStatusBar($(this).parents('.status-bar'));
		});
	}

	removeStatusBar($statusBar) {
		const self = this;

		$statusBar.fadeOut(300);
	}
}
